var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticStyle: { "margin-top": "8vh" },
      attrs: {
        visible: _vm.dialogVisible,
        title: "选择商品",
        width: "1000px",
        "append-to-body": true,
        modal: false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          attrs: { model: _vm.searchForm, size: "mini", inline: "" },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-form-item", [
                    _c(
                      "div",
                      { staticClass: "input-with-select" },
                      [
                        _c("span", { staticClass: "prepend-text" }, [
                          _vm._v("商品名称"),
                        ]),
                        _c("el-input", {
                          attrs: { placeholder: "请输入" },
                          model: {
                            value: _vm.searchForm.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "name", $$v)
                            },
                            expression: "searchForm.name",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-form-item", [
                    _c("div", { staticClass: "input-with-select" }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            width: "210px",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "category-select",
                              staticStyle: { width: "120px" },
                              attrs: { placeholder: "选择类型", clearable: "" },
                              model: {
                                value: _vm.codeSearchType,
                                callback: function ($$v) {
                                  _vm.codeSearchType = $$v
                                },
                                expression: "codeSearchType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "商品编码", value: "goodsNo" },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: "商品外部编码",
                                  value: "outGoodsNo",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("el-input", {
                            staticClass: "value-select",
                            staticStyle: { width: "120px" },
                            attrs: { placeholder: "请输入", clearable: "" },
                            model: {
                              value: _vm.codeSearchValue,
                              callback: function ($$v) {
                                _vm.codeSearchValue = $$v
                              },
                              expression: "codeSearchValue",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "input-with-select", attrs: { span: 8 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.searchGoods },
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    { attrs: { size: "mini" }, on: { click: _vm.resetSearch } },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
        },
        [
          _c("lb-table", {
            directives: [
              {
                name: "horizontal-scroll",
                rawName: "v-horizontal-scroll",
                value: "always",
                expression: '"always"',
              },
            ],
            ref: "tableRef",
            attrs: {
              border: "",
              column: _vm.columns,
              align: "center",
              data: _vm.goodsList,
              pagination: "",
              total: _vm.page.totalNum,
              layout: "total, sizes, prev, pager, next, jumper",
              "page-sizes": [5, 10, 20, 30, 50, 200],
              "current-page": _vm.page.currentPage,
              "page-size": _vm.page.pageSize,
              orderStatistics: _vm.page.totalNum,
              "is-goods-selector": "",
              statisticText: "当前列表统计总商品数",
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.page, "currentPage", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.page, "currentPage", $event)
              },
              "size-change": _vm.handleSizeChange,
              "p-current-change": _vm.handleCurrentChange,
              refresh: _vm.fetchData,
              "selection-change": _vm.handleTableSelectionChange,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm.confirmSelection },
            },
            [_vm._v("提交")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "mini" },
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }